import React from 'react';

import {
  Input,
  Icon,
  Button,
  Checkbox,
  Modal,
  AppLocaleProvider
} from 'sd-ui-components';
import { inject, observer } from 'mobx-react';
import './Login.less';
import Notifications from '../../components/Notifications/Notifications';

const { FormattedMessage, injectIntl } = AppLocaleProvider;

@inject('ConfigStore')
@inject('AuthStore')
@observer
class LoginForm extends React.Component {
  state = {
    helpModalVisible: false
  };

  updateLoginInfo = (key, value) => {
    this.props.AuthStore.loginInfo[key] = value;
  };

  onChangeLoginInfo = event => {
    this.updateLoginInfo(event.target.name, event.target.value);
  };

  onChangeLoginInfoCheckbox = event => {
    this.updateLoginInfo(event.target.name, event.target.checked);
  };

  login = () => {
    this.props.AuthStore.login();
  };

  loginAuth0 = () => {
    this.props.AuthStore.loginAuth0();
  };

  toggleModal = () => {
    this.setState({
      helpModalVisible: !this.state.helpModalVisible
    });
  };

  render() {
    const { loginInfo } = this.props.AuthStore;

    return (
      <div>
        <div>
          <a href={'/'}>
            <Icon icon="arrow-left" className="login-arrow-icon" />{' '}
            <FormattedMessage id="App.Login.Back" defaultMessage="Back" />{' '}
          </a>
        </div>
        <div>
          <h1>
            <FormattedMessage
              id="App.Login.DriverLogin"
              defaultMessage="Driver login"
            />
            {!this.props.ConfigStore.config.betaMode && (
              <Icon
                icon="question-circle-o"
                size={20}
                className="login-help-icon"
                onClick={this.toggleModal}
              />
            )}
          </h1>
          <Modal
            title={
              <h3>
                <FormattedMessage
                  id="App.Login.NeedHelp"
                  defaultMessage="Need help?"
                />
              </h3>
            }
            visible={this.state.helpModalVisible}
            footer={[
              <Button key="closeButton" onClick={this.toggleModal}>
                <FormattedMessage
                  id="App.Navigation.Close"
                  defaultMessage="Close"
                />
              </Button>
            ]}
            wrapClassName="login-help-modal"
            closable={false}
          >
            <p>
              <FormattedMessage
                id="App.Help.GlobalTechnicalSupport"
                defaultMessage="Global technical support"
              />
              <br />
              <FormattedMessage
                id="App.Help.USPhoneTitle"
                defaultMessage="US Toll free"
              />
              {': '}
              <a href="tel:8669339930">(866) 933-9930</a>
              <br />
              <FormattedMessage
                id="App.Help.UKPhoneTitle"
                defaultMessage="UK"
              />
              {': '}
              <a href="tel:08000470968">0800 0470968</a>
              <br />
              <a href="mailto:customer.service@smartdrive.net">
                customer.service@smartdrive.net
              </a>
            </p>
            <p>
              <FormattedMessage
                id="App.Help.GlobalPartsService"
                defaultMessage="Global Parts and Service"
              />
              <br />
              <FormattedMessage
                id="App.Help.USPhoneTitle"
                defaultMessage="US Toll-free"
              />
              {': '}
              <a href="tel:8669339930">(866) 933-9930</a> (
              <FormattedMessage
                id="App.Help.PhoneOption"
                defaultMessage="Option 3"
              />
              )<br />
              <FormattedMessage
                id="App.Help.UKPhoneTitle"
                defaultMessage="UK"
              />
              {': '}
              <a href="tel:08000470968">0800 0470968</a> (
              <FormattedMessage
                id="App.Help.PhoneOption"
                defaultMessage="Option 3"
              />
              )<br />
              <a href="mailto:parts-service@smartdrive.net">
                parts-service@smartdrive.net
              </a>
            </p>
          </Modal>
        </div>
        <div>
          {this.props.ConfigStore.config.fleetLoginUrl && (
            <a href={this.props.ConfigStore.config.fleetLoginUrl}>
              <FormattedMessage
                id="App.Login.TakeMeToFleetLogin"
                defaultMessage="Not a driver? Log in here instead"
              />{' '}
              <Icon icon="arrow-right" className="login-arrow-icon" />{' '}
            </a>
          )}
        </div>
        <div>
          <Notifications />
        </div>
        <div>
          <Input
            aria-label="company"
            name="company"
            className="login-company-input"
            value={loginInfo.company}
            onChange={this.onChangeLoginInfo}
            placeholder={this.props.intl.formatMessage({
              id: 'App.Login.Company',
              defaultMessage: 'Company'
            })}
          />
        </div>
        <div>
          <Input
            aria-label="userName"
            name="userName"
            className="login-input"
            value={loginInfo.userName}
            onChange={this.onChangeLoginInfo}
            placeholder={this.props.intl.formatMessage({
              id: 'App.Login.UserName',
              defaultMessage: 'User name'
            })}
          />
        </div>
        <div>
          <Input
            aria-label="password"
            name="password"
            type="password"
            className="login-input"
            value={loginInfo.password}
            onChange={this.onChangeLoginInfo}
            onPressEnter={this.login}
            placeholder={this.props.intl.formatMessage({
              id: 'App.Login.Password',
              defaultMessage: 'Password'
            })}
          />
        </div>
        <div className="login-password-remember-me-row">
          <Checkbox
            name="rememberMe"
            checked={loginInfo.rememberMe}
            onClick={this.onChangeLoginInfoCheckbox}
          >
            <FormattedMessage
              id="App.Login.RememberMe"
              defaultMessage="Remember me on this device"
            />
          </Checkbox>
          {/* todo: link this up */}
          <a
            className="login-link-forgot-password"
            href={this.props.ConfigStore.config.forgotPasswordUrl}
          >
            <FormattedMessage
              id="App.Login.ForgotPassword"
              defaultMessage="Forgot password?"
            />
          </a>
        </div>
        <div>
          <Button
            type="primary"
            size="large"
            className="login-button"
            onClick={this.login}
            loading={this.props.AuthStore.loading.login}
          >
            <FormattedMessage id="App.Login.LogIn" defaultMessage="Log in" />
          </Button>
        </div>
        {this.props.ConfigStore.config.auth0LoginButtonEnabled && (
          <div>
            <Button
              type="primary"
              size="large"
              className="login-button"
              onClick={this.loginAuth0}
              loading={this.props.AuthStore.loading.login}
            >
              <FormattedMessage
                id="App.Login.LogInToAuth0"
                defaultMessage="Log in to Auth0"
              />
            </Button>
          </div>
        )}
      </div>
    );
  }
}

export default injectIntl(LoginForm);



// WEBPACK FOOTER //
// ./src/containers/Login/LoginForm.jsx